module.exports = __webpack_public_path__ + "img/flounces_width.6a6157ae.png";